import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * The site the operator is currently "in". Persisted so the site-scoped nav
 * (แดชบอร์ด / รายงาน) stays available even while browsing admin pages that have
 * no siteId in their URL — the whole point of the site-first sidebar. The URL is
 * still the source of truth while on /sites/:id/*; this store just remembers the
 * last one so the section never vanishes.
 */
interface CurrentSiteState {
  siteId: number | null;
  setSiteId: (id: number | null) => void;
}

export const useCurrentSite = create<CurrentSiteState>()(
  persist(
    (set) => ({
      siteId: null,
      setSiteId: (siteId) => set({ siteId }),
    }),
    { name: 'ledmonitor-current-site' },
  ),
);
